// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Ncea","row":"Node_row__32L8E","label":"Node_label__GohG4","footer":"Node_footer__2pNeV"};